import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { BackArrowIcon } from 'components/elements/Icons';
import { useFetchVideoChatMessagesDetails, useDeviceDetect, useVideoChatMessagesActions } from 'hooks';
import ChatMessageSendForm from 'components/modules/portal/ChatThread/ChatMessageSendForm';
import ChatMessages from 'components/modules/portal/ChatThread/ChatMessages';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function VideoChat({ sessionToken, sessionId, onClickBack, accountId, participants, attachmentUploadEnabled }) {
  const classes = useStyles();
  const { isDesktop } = useDeviceDetect();
  const { t } = useTranslation('labels');
  const { data: chatMessages, isLoading } = useFetchVideoChatMessagesDetails(sessionToken, sessionId);
  const { reply, download, downloadingList } = useVideoChatMessagesActions(sessionToken, sessionId);

  return (
    <div className={classes.videoChat} data-testid="chat-thread">
      <Typography className={classes.title} variant="h5" component="h5">
        {t('chat')}
      </Typography>
      {!isLoading ? (
        <>
          {!isDesktop && (
            <button className={classes.backButton} type="button" onClick={onClickBack}>
              <BackArrowIcon classes={classes.backIcon} />
            </button>
          )}
          <div className={classes.lineWrapper}>
            <div className={classes.thread}>
              <ChatMessages messages={chatMessages} isVideoChat accountId={accountId} participants={participants} onDownload={download} downloadingList={downloadingList} />
            </div>
          </div>
          <ChatMessageSendForm classes={classes.chatControls} onReply={reply} attachmentUploadEnabled={attachmentUploadEnabled} allowAttachments />
        </>
      ) : (
        <div className={classes.caption}>
          <Typography variant="subtitle1" component="span">
            {isLoading ? t('loading') : t('no_chats_available')}
          </Typography>
        </div>
      )}
    </div>
  );
}

VideoChat.propTypes = {
  sessionToken: PropTypes.string.isRequired,
  sessionId: PropTypes.string.isRequired,
  onClickBack: PropTypes.func.isRequired,
  accountId: PropTypes.string,
  participants: PropTypes.arrayOf(PropTypes.object),
  attachmentUploadEnabled: PropTypes.bool,
};

VideoChat.defaultProps = {
  participants: [],
  accountId: '',
  attachmentUploadEnabled: true,
};

export default VideoChat;
